function clean(value) {
  return String(value ?? "").trim();
}

function yearFromDate(value) {
  const raw = clean(value);
  return /^\d{4}/.test(raw) ? raw.slice(0, 4) : "";
}

function monthFromDate(value) {
  const month = Number(clean(value).slice(5, 7));
  if (!Number.isInteger(month) || month < 1 || month > 12) return "";
  return new Intl.DateTimeFormat("en-US", { month: "long", timeZone: "UTC" }).format(
    new Date(Date.UTC(2000, month - 1, 1)),
  );
}

export function formatTradeShowLocation(show) {
  return [show.city, show.state, show.country].map(clean).filter(Boolean).join(", ");
}

export function buildWorkspacePayloadFromTradeShow(show, { autoImport = true } = {}) {
  const location = formatTradeShowLocation(show);
  const year = yearFromDate(show.startDate) || yearFromDate(show.endDate);
  const month = monthFromDate(show.startDate) || monthFromDate(show.endDate);
  return {
    workspaceName: `${show.name}${year ? ` ${year}` : ""}`,
    tradeShowName: show.name,
    industry: show.industry || "",
    location,
    city: clean(show.city),
    state: clean(show.state),
    country: clean(show.country),
    month,
    year,
    auto_import_exhibitors: autoImport,
    selectedTradeShow: show,
  };
}
